import { format, isToday, isYesterday } from "date-fns";

export const doctorDisplayName = (doctor) => {
  const name = doctor?.name?.trim() || "Doctor";
  return /^dr\.?\s/i.test(name) ? name : `Dr. ${name}`;
};

export const initials = (name) => {
  const parts = String(name || "")
    .replace(/^Dr\.?\s*/i, "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  return (parts[0]?.[0] || "?").toUpperCase();
};

const toDate = (value) => {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};

export const formatMessageTime = (value) => {
  const d = toDate(value);
  if (!d) return "";
  return format(d, "h:mm a");
};

export const formatConversationTime = (value) => {
  const d = toDate(value);
  if (!d) return "";
  if (isToday(d)) return format(d, "h:mm a");
  if (isYesterday(d)) return "Yesterday";
  return format(d, "MMM d");
};

export const formatDateSeparator = (value) => {
  const d = toDate(value) || new Date();
  const time = format(d, "h:mm a");
  if (isToday(d)) return `Today, ${time}`;
  if (isYesterday(d)) return `Yesterday, ${time}`;
  return `${format(d, "MMM d, yyyy")}, ${time}`;
};

export const messageSnippet = (msg) => {
  if (!msg) return "No messages yet";
  if (msg.message?.trim()) return msg.message.trim();
  if (msg.file) return "Attachment";
  return "No messages yet";
};

export const fileNameFromUrl = (url) => {
  if (!url) return "Document";
  try {
    const path = new URL(url, window.location.origin).pathname;
    const base = path.split("/").pop() || "Document";
    return decodeURIComponent(base);
  } catch {
    const parts = String(url).split("/");
    return parts[parts.length - 1] || "Document";
  }
};
